import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Row,
  Spinner,
} from 'reactstrap';
import swal from 'sweetalert';

import { GET_BANNER_DETAIL } from 'utils';
import axios from 'axios';
import { EDIT_BANNER, GET_TOKEN } from 'utils';

export default function EditBanner() {
  const { id } = useParams();
  const idKu = id.split(',');
  const history = useHistory();

  const [gambar, setGambar] = useState('');
  const [nama, setNama] = useState('');
  const [page, setPage] = useState('');
  const [gambarLama, setGambarLama] = useState(false);
  const [keterangan, setKeterangan] = useState('');

  const [urlFile1, setUrlFile1] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);

  // auth

  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token', {
        credentials: 'include',
      });
      setAccessToken(response.data.accessToken);
    } catch (error) {
      if (error.response) {
        history.push('/admin/banner');
      }
    }
  };
  //auth

  useEffect(() => {
    refreshToken();
    getDetailBanner();
  }, [id]);

  const getDetailBanner = async () => {
    var data1 = [];

    try {
      const response = await axios.get(GET_BANNER_DETAIL + `${idKu[0]}`);
      data1 = response.data.data[0];

      if (data1) {
        setUrlFile1(data1.gambar.split(',')[0]);
        setGambarLama(data1.gambar.split(',')[0]);

        setNama(data1.nama);
        setPage(data1.page);
        setKeterangan(data1.keterangan);
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  function onChange1(e) {
    let uploaded = e.target.files[0];
    setUrlFile1(URL.createObjectURL(uploaded));
    setGambar(e.target.files[0]);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveLoading(true);

    if (gambarLama && nama && page && keterangan) {
      //action
      // this.props.dispatch(updateJersey(this.state));

      const formData = new FormData();
      formData.append('photo', gambar);

      formData.append('nama', nama);
      formData.append('page', page);
      formData.append('keterangan', keterangan);
      let rubah = gambarLama.trim() !== urlFile1.trim() ? 'True' : 'False';
      formData.append('rubahFoto', rubah);
      formData.append('gambarLama', gambarLama);
      formData.append('idAdmin', idKu[1]);

      const response = await axios.patch(EDIT_BANNER + `${idKu[0]}`, formData, {
        credentials: 'include',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data.success === 1) {
        swal('Success', 'Banner berhasil diedit', 'success');
        history.push('/admin/banner');
      }
    } else {
      swal('Failed', 'Maaf semua form wajib diisi', 'error');
    }
    setSaveLoading(false);
  };

  return (
    <div className='content'>
      <Row>
        <Col>
          <Link to='/admin/banner' className='btn btn-primary'>
            Kembali
          </Link>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardHeader tag='h4'>Edit Banner</CardHeader>
            <CardBody>
              <form onSubmit={(event) => handleSubmit(event)}>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col>
                        <img src={urlFile1} width='400' alt='Gambar Banner' />
                        <FormGroup>
                          <label>Foto Toko (satu)</label>
                          <Input
                            type='file'
                            name='image1'
                            accept={'image/*'}
                            onChange={(event) => onChange1(event, 'imageToDB1')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label>Nama Banner</label>
                      <Input
                        type='text'
                        value={nama}
                        name='nama'
                        onChange={(event) => setNama(event.target.value)}
                      />
                    </FormGroup>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Page</label>
                          <Input
                            type='text'
                            value={page}
                            name='jenis'
                            onChange={(event) => setPage(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Keterangan</label>
                          <Input
                            type='text'
                            value={keterangan}
                            name='harga'
                            onChange={(event) =>
                              setKeterangan(event.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    {saveLoading ? (
                      <Button color='primary' type='submit' disabled>
                        <Spinner size='sm' color='light' /> Loading
                      </Button>
                    ) : (
                      <Button type='submit' color='danger' className='ml-2'>
                        <i className='nc-icon nc-basket'></i> Simpan
                      </Button>
                    )}
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
